import type { SxProps, Theme } from '@mui/material/styles';
import type { StackProps } from '@mui/material';

export const getCardSx = (isEmpty?: boolean): SxProps<Theme> => ({
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  gap: 2,
  backgroundColor: '#99A8FF1A',
  opacity: isEmpty ? 0.6 : 1,
});

export const quantityTextSx: SxProps<Theme> = {
  position: 'absolute',
  top: '16px',
  right: '16px',
  fontSize: 16,
};

export const badgeImgSx: SxProps<Theme> = {
  width: '63px',
  height: 'auto',
};

export const titleStackProps: StackProps = {
  sx: {
    alignItems: 'center',
  },
};

export const hoursTextSx: SxProps<Theme> = {
  fontSize: 16,
  textAlign: 'center',
};

export const subtitleTextSx: SxProps<Theme> = {
  fontSize: 16,
  textAlign: 'center',
  color: '#CCD4FF',
  whiteSpace: 'nowrap',
};

export const emptyOverlaySx: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  opacity: 0,
  zIndex: 1,
};
